import { z } from "zod";
import * as regex from "../utils/regex";
export const guidSchema = z.string().refine((val) => regex.GUID.test(val), {
    message: "Invalid GUID",
});
